module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAABYlAAAWJQFJUiTwAAAA20lEQVRYhe2UwQ3CMAxFfxADMAKDdAi6ASwQiUmQskBHgCEyCCOwQVClcIml2E5CBZLf0U3c1y+7MIxOnOR68tMJwA3AkTzMuBBdPru4EC/kgJCdUOZekyk4r1KkOkooJ6OlWaoqlPx0UCRT0iRVFRqAWqoq5EJ8kaIelVRVaCBiqa2EIJXak0onn/9RK1smJIL9muSnRIo9L2QS/LmETIhDvWXaLdLO4P8nNHrrSmyoOWzLOGzLOGyoOSRCT1Jph+0lEbqSSjtsL1bIhfgAMHcmtd6dcy/D+B4A3rhePgqPO3rpAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PC/@2x/ic_btn_confirmation@2x.png
// module id = 738
// module chunks = 0